// extracted by mini-css-extract-plugin
export var author = "Testimonials-module--author--a7e10";
export var core = "Testimonials-module--core--28dc1";
export var slider = "Testimonials-module--slider--fdf34";
export var testimonial = "Testimonials-module--testimonial--1eb2b";